var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1173,
    height: 1173,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2855,
    y: 1251,
    width: 1173,
    height: 1173
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3229.33 1266.06 3630.64 1596.25 3260.2 2046.48 2858.89 1716.29Z",
    fillRule: "nonzero",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3229.33 1266.06 3630.64 1596.25 3260.2 2046.48 2858.89 1716.29Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3055.35 636.695 3883.44 1318.03 3037.76 2345.86 2209.67 1664.52Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3661.42 2388.74 3255.6 2064.1 3619.82 1608.82 4025.63 1933.45Z",
    fillRule: "nonzero",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3661.42 2388.74 3255.6 2064.1 3619.82 1608.82 4025.63 1933.45Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3844.04 3015.65 3006.66 2345.77 3838.11 1306.41 4675.5 1976.28Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2855 -1251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2859 1836.5C2859 1513.69 3120.69 1252 3443.5 1252 3766.31 1252 4028 1513.69 4028 1836.5 4028 2159.31 3766.31 2421 3443.5 2421 3120.69 2421 2859 2159.31 2859 1836.5Z",
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.807 569.991 913.893 569.991 814.532 669.351C801.577 682.306 801.577 703.311 814.532 716.267 827.488 729.222 848.493 729.222 861.448 716.267L1017.72 559.948C1030.68 547.61 1031.18 527.105 1018.84 514.15 1018.48 513.769 1018.1 513.396 1017.72 513.033L861.414 356.759C849.076 343.804 828.571 343.304 815.616 355.642 815.235 356.005 814.862 356.378 814.499 356.759 801.544 369.098 801.043 389.603 813.382 402.558 813.745 402.939 814.118 403.312 814.499 403.675L913.859 503.091 78.807 503.091C60.2993 503.091 45.2959 518.094 45.2959 536.602 45.2959 555.111 60.2993 570.113 78.807 570.113Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(0.772213 0.635364 -0.78862 0.958478 3055.35 636.695)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.807 569.991 913.893 569.991 814.532 669.351C801.577 682.306 801.577 703.311 814.532 716.267 827.488 729.222 848.493 729.222 861.448 716.267L1017.72 559.948C1030.68 547.61 1031.18 527.105 1018.84 514.15 1018.48 513.769 1018.1 513.396 1017.72 513.033L861.414 356.759C849.076 343.804 828.571 343.304 815.616 355.642 815.235 356.005 814.862 356.378 814.499 356.759 801.544 369.098 801.043 389.603 813.382 402.558 813.745 402.939 814.118 403.312 814.499 403.675L913.859 503.091 78.807 503.091C60.2993 503.091 45.2959 518.094 45.2959 536.602 45.2959 555.111 60.2993 570.113 78.807 570.113Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(-0.780882 -0.624678 0.775357 -0.969239 3844.04 3015.65)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapClose);
export default __webpack_public_path__ + "static/media/map-close.91e47d373fedb1db7249e38de80b513b.svg";
export { ForwardRef as ReactComponent };